import React, {useState} from 'react';
import TableCell from "@mui/material/TableCell";
import Box from "@mui/material/Box";
import TableRow from "@mui/material/TableRow";
import UngroupDialog from "../UngroupDialog";
import GoodsTable from "./GoodsTable";

const GoodsTableWrapper = ({shipping, showUngroup = true}) => {
    const [showUngroupDialog, setShowUngroupDialog] = useState(false);

    return (
        <>
            <TableRow>
                <TableCell/>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={showUngroup ? 6 : 7}>
                    <Box margin={1}>
                        <GoodsTable
                            showUngroupBtn={showUngroup}
                            ungroupOnClick={() => setShowUngroupDialog(true)}
                            shipping={shipping}
                            selectable={false}
                        />
                    </Box>
                </TableCell>
            </TableRow>
            {showUngroup && <UngroupDialog
                open={showUngroupDialog}
                setOpen={setShowUngroupDialog}
                shipping={shipping}
            />}
        </>
    );
};

export default GoodsTableWrapper;